import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Zap, Target } from 'lucide-react';

export function DashboardQuickActions() {
    const navigate = useNavigate();
    
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Card className="bg-gradient-to-r from-blue-500 to-blue-600 text-white">
                <CardContent className="pt-6">
                    <div className="flex items-center justify-between">
                        <div>
                            <h3 className="font-semibold text-lg">Nouveau Prospect</h3>
                            <p className="text-blue-100 text-sm mt-1">Ajouter un nouveau dossier</p>
                        </div>
                        <Button 
                            variant="secondary" 
                            onClick={() => navigate('/prospects/new')}
                            data-testid="new-prospect-btn"
                        >
                            <Zap className="w-4 h-4 mr-2" />
                            Creer
                        </Button>
                    </div>
                </CardContent>
            </Card>

            <Card className="bg-gradient-to-r from-slate-700 to-slate-800 text-white">
                <CardContent className="pt-6">
                    <div className="flex items-center justify-between">
                        <div>
                            <h3 className="font-semibold text-lg">Voir le Pipeline</h3>
                            <p className="text-slate-300 text-sm mt-1">Gerer vos dossiers</p>
                        </div>
                        <Button 
                            variant="secondary"
                            onClick={() => navigate('/pipeline')}
                            data-testid="view-pipeline-btn"
                        >
                            <Target className="w-4 h-4 mr-2" />
                            Ouvrir
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
